import i18n from '@plugins/i18n';

import Collection from '@/models/Collection';
import RestrictedPanel from '@/models/RestrictedPanel';

export class RestrictedPanelsCollection extends Collection {
    static type = 'RestrictedPanelsCollection';
    static endpoint = RestrictedPanel.api.index;
    static model = RestrictedPanel;

    static fields() {
        return {
            ...super.fields(),
            adviser_id: this.string(null).nullable()
        };
    }

    get preset_filters() {
        const filters = {};

        if (this.adviser_id) {
            filters.adviser_id = this.filterOperator('is') + ':' + this.adviser_id;
        }

        return filters;
    }

    get headers() {
        return [
            this.createHeader('name', i18n.t('name'), {
                filterable: true,
                sortable: true,
                sticky: true,
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('default', i18n.t('default'), {
                format: 'boolean',
                width: '6rem'
            })
        ];
    }

    get default_headers() {
        return ['name', 'default'];
    }
}

export default RestrictedPanelsCollection;
